import SurgeSounds from "./../images/projects/surge-sounds.jpg";
import KeeperApp from "./../images/projects/keeper-app.png";
import ToDoList from "./../images/projects/todolist.png";
import Portfolio from "./../images/projects/portfolio.png";
import CatBird from "./../images/projects/journal.png";
import Newsletter from "./../images/projects/newsletter-signup.png";
import Secrets from "./../images/projects/secrets.png";
import BaseApparel from "./../images/projects/base-apparel.jpg";
import FourCard from "./../images/projects/four-card.jpg";
import SignUpForm from "./../images/projects/sign-up-form.jpg";

const projectsMain = [
    {
    imageUrl: SurgeSounds,
    name: "surge sounds website",
    link: "https://surgesounds.com/",
    title: "Surge Sounds - Built with WordPress & React",
    description: "Core Tech: WordPress PHP React Babel Javascript ES6 CSS3 HTML5",
    type: "frontend",
    },
    {
    imageUrl: KeeperApp,
    name: "four card feature section landing page",
    link: "https://kuroiwaaiki.github.io/Keeper-App/",
    title: "Keeper App - Built with React & Material-UI",
    description: "Core Tech: React Material-UI Babel Webpack Node.js Javascript ES6 CSS3 HTML5",
    type: "backend",
    },
    {
    imageUrl: Newsletter,
    name: "newsletter signup",
    link: "https://kuroiwa-ns.herokuapp.com/",
    title: "Newsletter Sign Up - Built with Express & Mailchimp",
    description: "Core Tech: Bootstrap Mailchimp Express Heroku Body Parser Node.js Javascript ES6 CSS3 HTML5",
    type: "backend",
    },
    {
    imageUrl: Portfolio,
    name: "portfolio",
    link: "https://github.com/KuroiwaAiki/Jamesmummery",
    title: "Portfolio - Built with React & Material UI",
    description: "Core Tech: React Material UI React Router Babel Webpack Node.js Javascript ES6 CSS3 HTML5",
    type: "backend",
    },
    {
    imageUrl: CatBird,
    name: "daily journal",
    link: "https://kuroiwa-journal.herokuapp.com/",
    title: "Journal - Built with Express & Heroku Cloud PaaS",
    description: "Core Tech: MongoDB Mongoose Express Heroku EJS Body Parser Lodash Node.js Javascript ES6 CSS3 HTML5",
    type: "backend",
    },
    {
    imageUrl: ToDoList,
    name: "to do list ",
    link: "https://todolist-kuroiwa-aiki.herokuapp.com/",
    title: "To Do List - Built with Express & Heroku Cloud PaaS",
    description: "Core Tech: MongoDB Mongoose Express Heroku EJS Body Parser Lodash Node.js Javascript ES6 CSS3 HTML5",
    type: "backend",
    },
    {
    imageUrl: BaseApparel,
    name: "base apparel",
    link: "https://kuroiwaaiki.github.io/Base-Apparel-landing-page/",
    title: "Base Apparel Landing Page",
    description: "Core Tech: Javascript ES6 CSS3 HTML5",
    type: "frontend",
    },
    {
    imageUrl: FourCard,
    name: "Powered by Technology",
    link: "https://kuroiwaaiki.github.io/Four-Card-Feature-Section/",
    title: "Powered by Technology",
    description: "Core Tech: Javascript ES6 CSS3 HTML5",
    ype: "frontend",
    },
    {
    imageUrl: SignUpForm,
    name: "Form Authentication",
    link: "https://kuroiwaaiki.github.io/Sign-up-Form/",
    title: "JS Form Authentication",
    description: "Core Tech: Javascript ES6 CSS3 HTML5",
    type: "frontend",
    },
    {
    imageUrl: Secrets,
    name: "secrets landing page",
    link: "https://kuroiwa-secrets.herokuapp.com/",
    title: "Secrets - Built with Express & Google / Facebook OAuth",
    description: "Core Tech: MongoDB Mongoose Express Heroku Bootstrap EJS Node.js Passport Body Parser Javascript ES6 CSS3 HTML5",
    type: "backend",
    },
]

export default projectsMain;